<template>
  <div class="flex flex-wrap items-center">
    <div class="w-8 flex items-center justify-center">
      <div class="flex items-center justify-center w-5 h-5 rounded bg-white cursor-pointer" @click="content = !content">
        <icon v-show="content" class="text-black" icon="check"/>
      </div>
    </div>
    <div class="flex-1 break-all">
      <input ref="name"
             spellcheck="false"
             v-model="name"
             class="w-full px-1 border-1 bg-transparent"
             :class="editName ? 'text-input' : 'pointer-events-none'"
             @keypress.enter="rename"
             @blur="rename"
      />
    </div>
  </div>
</template>

<script>
import attributeMixin from '@/mixins/attribute'
export default {
  mixins: [attributeMixin]
}
</script>
